import React from "react";
import styled from "@emotion/styled";
import { useIntl } from "gatsby-plugin-intl";

const contactCustomerServiceUrl = "https://support.pinkcore.com"

const StyledButton = styled.a`
  width: 240px;
  height: 50px;
  background-color: #4B0827;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1rem;
  text-decoration: none;
  
  @media (min-width: 768px) {
    width: 480px;
    height: 100px;
    font-size: 2rem;
  }
`;

const ContactCustomerServiceButton = () => {
  const intl = useIntl();
  const { formatMessage } = intl;

  return (
    <StyledButton
      href={contactCustomerServiceUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {formatMessage({ id: 'contact_customer_service' })}
    </StyledButton>
  );
};

export default ContactCustomerServiceButton;